import { Injectable } from '@angular/core';
import { ISuppliersApiService } from './suppliers-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { CreateSupplierRequestDto } from './dtos/create-supplier.request.dto';
import { CreateSupplierResponseDto } from './dtos/create-supplier.response.dto';
import { ExportSuppliersQueryDto } from './dtos/export-suppliers.query.dto';
import { FindSupplierNamesResponseDto } from './dtos/find-supplier-names.response.dto';
import { FindSupplierResponseDto } from './dtos/find-supplier.response.dto';
import { FindSuppliersQueryDto } from './dtos/find-suppliers.query.dto';
import { FindSuppliersResponseDto } from './dtos/find-suppliers.response.dto';
import { UpdateSupplierRequestDto } from './dtos/update-supplier.request.dto';
import { UpdateSupplierResponseDto } from './dtos/update-supplier.response.dto';

@Injectable({
  providedIn: 'root',
})
export class SuppliersMockApiService implements ISuppliersApiService {
  findSuppliers(
    query: FindSuppliersQueryDto,
  ): Promise<FindSuppliersResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportSuppliers(
    query: ExportSuppliersQueryDto,
    options?: HandleBlobHttpResponseOptions,
  ): Promise<void> {
    throw new Error('Method not implemented.');
  }
  findSupplierNames(): Promise<FindSupplierNamesResponseDto> {
    throw new Error('Method not implemented.');
  }
  findSupplier(supplierId: number): Promise<FindSupplierResponseDto> {
    throw new Error('Method not implemented.');
  }
  createSupplier(
    data: CreateSupplierRequestDto,
  ): Promise<CreateSupplierResponseDto> {
    throw new Error('Method not implemented.');
  }
  updateSupplier(
    supplierId: number,
    data: UpdateSupplierRequestDto,
  ): Promise<UpdateSupplierResponseDto> {
    throw new Error('Method not implemented.');
  }
  deleteSupplier(supplierId: number): Promise<void> {
    throw new Error('Method not implemented.');
  }
  deleteSuppliers(supplierIds: number[]): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
